module.exports = __webpack_public_path__ + "img/1397838472.5f3cd3ad.jpg";